
export default {
  'routeExtras': {
    'extras': 'Extras d\'itinéraire',
    'extraInfo': 'Inform. supplémentaires',
    'value': 'Valeur',
    'clickToHighlightOnMap': 'Cliquez pour le mettre en évidence sur la carte',
    'showAllOnMap': 'Tout afficher sur la carte'
  }
}
